import {
  Divider,
  FormControl,
  FormControlLabel,
  GKRadio,
  Grid2,
  InfoItalicIcon,
  RadioGroup,
  Show,
  Typography,
} from "components";
import { Controller, useFormContext } from "react-hook-form";
import { handleCapitalize } from "utils/common";
import {
  allocationBy,
  allocationExitBy,
  currentAllocation,
  rebalanceCustomParameter,
  rebalanceUsing,
  weightageDistributionMethod,
} from "./utils";

interface Props {
  watchAllocationType: string;
}

const AllocationTemplate = (props: Props) => {
  const form = useFormContext();

  const { watchAllocationType } = props;
  const watchAllocationBy = form.watch(`${watchAllocationType}.allocationBy`);

  return (
    <Grid2 container spacing={4}>
      <Grid2 size={12} display={"flex"} alignItems={"center"} gap={"6px"}>
        <InfoItalicIcon />
        <Typography fontSize={12} fontWeight={600} color=" #44484F">
          {handleCapitalize(watchAllocationType)}:{" "}
          <span style={{ fontSize: 12, fontWeight: 500, color: " #697586" }}>
            Allocate new/fresh funds in a model or a company
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12} container spacing={1}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
            {watchAllocationType === "allocation"
              ? "Allocation By"
              : watchAllocationType === "rebalance"
                ? "Rebalance By"
                : "Exit By"}
          </Typography>
        </Grid2>
        <Grid2 size={4}>
          <Typography fontSize={12} fontWeight={500} color={"#697586"}>
            Select your base for order creation, a model or a company.
          </Typography>
        </Grid2>
        <Grid2 size={8}>
          <Controller
            name={`${watchAllocationType}.allocationBy`}
            control={form.control}
            render={({ field }) => (
              <FormControl>
                <RadioGroup
                  row
                  {...field}
                  onChange={(e) => {
                    field.onChange(e.target.value);

                    // if (
                    //   watchAllocationType === "rebalance" &&
                    //   e.target.value === "company"
                    // ) {
                    //   form.setValue("rebalance.stockWise", true);
                    // } else {
                    //   form.setValue("rebalance.stockWise", false);
                    // }
                  }}
                >
                  {(watchAllocationType === "exit"
                    ? allocationExitBy
                    : allocationBy.filter((dataItem) =>
                        watchAllocationType !== "rebalance"
                          ? dataItem.value !== "customized"
                          : dataItem,
                      )
                  ).map((item) => (
                    <FormControlLabel
                      label={item.name}
                      value={item.value}
                      control={
                        <GKRadio disableTopPadding disableBottomPadding />
                      }
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            )}
          />
        </Grid2>
      </Grid2>
      <Show.When
        isTrue={
          (watchAllocationType === "allocation" &&
            watchAllocationBy === "version") ||
          watchAllocationType === "rebalance"
        }
      >
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12} container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
              Model Reference Weightage:
            </Typography>
          </Grid2>
          <Grid2 size={4}>
            <Typography fontSize={12} fontWeight={500} color={"#697586"}>
              Select your model weightage preference to be used for order
              creation
            </Typography>
          </Grid2>
          <Grid2 size={8}>
            <Controller
              name={`${watchAllocationType}.useCurrentAllocation`}
              control={form.control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {currentAllocation.map((item, index) => (
                      <Grid2 container size={12}>
                        <Grid2 size={12} mt={index !== 0 && 2}>
                          <FormControlLabel
                            value={item.value}
                            control={
                              <GKRadio disableTopPadding disableBottomPadding />
                            }
                            label={
                              <Typography
                                fontSize={14}
                                fontWeight={500}
                                display="inline"
                                color="#333"
                              >
                                {item.name}
                              </Typography>
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} ml={"38px"}>
                          <Typography
                            fontSize={12}
                            fontWeight={500}
                            color=" #697586"
                          >
                            {item.subText}
                          </Typography>
                        </Grid2>
                      </Grid2>
                    ))}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid2>
        </Grid2>
      </Show.When>
      <Show.When
        isTrue={
          watchAllocationType === "allocation" ||
          (watchAllocationType === "exit" &&
            watchAllocationBy === "companyWeightage") ||
          watchAllocationType === "rebalance"
        }
      >
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12} container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
              {`${handleCapitalize(watchAllocationType)} Reference Value`}:
            </Typography>
          </Grid2>
          <Grid2 size={4}>
            <Typography fontSize={12} fontWeight={500} color={"#697586"}>
              {`Select your ${handleCapitalize(watchAllocationType)} reference value for order generation`}
            </Typography>
          </Grid2>
          <Grid2 size={8}>
            <Controller
              name={`${watchAllocationType}.rebalanceUsing`}
              control={form.control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {rebalanceUsing
                      .filter(
                        (dataItem) =>
                          dataItem?.allocationType?.includes(
                            watchAllocationType,
                          ) &&
                          dataItem[
                            watchAllocationType as keyof typeof dataItem
                          ]?.includes(watchAllocationBy),
                      )
                      .map((dataItem, index) => {
                        return (
                          <Grid2 container size={12} mt={index !== 0 && 2}>
                            <Grid2 size={12}>
                              <FormControlLabel
                                value={dataItem.value}
                                control={
                                  <GKRadio
                                    disableTopPadding
                                    disableBottomPadding
                                  />
                                }
                                label={
                                  <Typography
                                    fontSize={14}
                                    fontWeight={500}
                                    display="inline"
                                    color="#333"
                                  >
                                    {dataItem.name}
                                  </Typography>
                                }
                              />
                            </Grid2>
                            <Grid2 size={12} ml={"38px"}>
                              <Typography
                                fontSize={12}
                                fontWeight={500}
                                color=" #697586"
                              >
                                {dataItem.subText}
                              </Typography>
                            </Grid2>
                          </Grid2>
                        );
                      })}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid2>
        </Grid2>
      </Show.When>
      <Show.When
        isTrue={
          (watchAllocationType === "allocation" &&
            watchAllocationBy === "version") ||
          (watchAllocationType === "rebalance" &&
            watchAllocationBy !== "customized")
        }
      >
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12} container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
              Weightage Distribution Method:
            </Typography>
          </Grid2>
          <Grid2 size={4}>
            <Typography fontSize={12} fontWeight={500} color={"#697586"}>
              This is important when you adjust your order after holding assets.
            </Typography>
          </Grid2>
          <Grid2 size={8}>
            <Controller
              name={`${watchAllocationType}.weightageDistributionMethod`}
              control={form.control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {weightageDistributionMethod.map((item, index) => (
                      <Grid2 container size={12} mt={index !== 0 && 2}>
                        <Grid2 size={12}>
                          <FormControlLabel
                            value={item.value}
                            control={
                              <GKRadio disableTopPadding disableBottomPadding />
                            }
                            label={
                              <Typography
                                fontSize={14}
                                fontWeight={500}
                                display="inline"
                                color="#333"
                              >
                                {item.name}
                              </Typography>
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} ml={"38px"}>
                          <Typography
                            fontSize={12}
                            fontWeight={500}
                            color=" #697586"
                          >
                            {item.subText}
                          </Typography>
                        </Grid2>
                      </Grid2>
                    ))}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid2>
        </Grid2>
      </Show.When>

      <Show.When
        isTrue={
          watchAllocationType === "rebalance" &&
          watchAllocationBy === "customized"
        }
      >
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12} container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
              Exit Parameter:
            </Typography>
          </Grid2>
          <Grid2 size={4}>
            <Typography fontSize={12} fontWeight={500} color={"#697586"}>
              ABCDEFGHIJKLMNOPQRSTUVWXYZ
            </Typography>
          </Grid2>
          <Grid2 size={8}>
            <Controller
              name={`${watchAllocationType}.exitParameter`}
              control={form.control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {rebalanceCustomParameter.map((item, index) => (
                      <Grid2 container size={12} mt={index !== 0 && 2}>
                        <Grid2 size={12}>
                          <FormControlLabel
                            value={item.value}
                            control={
                              <GKRadio disableTopPadding disableBottomPadding />
                            }
                            label={
                              <Typography
                                fontSize={14}
                                fontWeight={500}
                                display="inline"
                                color="#333"
                              >
                                {item.name}
                              </Typography>
                            }
                          />
                        </Grid2>
                        {/* <Grid2 size={12} ml={"38px"}>
                          <Typography
                            fontSize={12}
                            fontWeight={500}
                            color=" #697586"
                          >
                            {item.subText}
                          </Typography>
                        </Grid2> */}
                      </Grid2>
                    ))}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12} container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={12} fontWeight={700} color={" #20272A"}>
              Buy Parameter:
            </Typography>
          </Grid2>
          <Grid2 size={4}>
            <Typography fontSize={12} fontWeight={500} color={"#697586"}>
              ABCDEFGHIJKLMNOPQRSTUVWXYZ
            </Typography>
          </Grid2>
          <Grid2 size={8}>
            <Controller
              name={`${watchAllocationType}.buyParameter`}
              control={form.control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {rebalanceCustomParameter
                      .filter(
                        (dataItem) => dataItem?.value !== "companyAbsolute",
                      )
                      .map((item, index) => (
                        <Grid2 container size={12} mt={index !== 0 && 2}>
                          <Grid2 size={12}>
                            <FormControlLabel
                              value={item.value}
                              control={
                                <GKRadio
                                  disableTopPadding
                                  disableBottomPadding
                                />
                              }
                              label={
                                <Typography
                                  fontSize={14}
                                  fontWeight={500}
                                  display="inline"
                                  color="#333"
                                >
                                  {item.name}
                                </Typography>
                              }
                            />
                          </Grid2>
                          {/* <Grid2 size={12} ml={"38px"}>
                          <Typography
                            fontSize={12}
                            fontWeight={500}
                            color=" #697586"
                          >
                            {item.subText}
                          </Typography>
                        </Grid2> */}
                        </Grid2>
                      ))}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid2>
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default AllocationTemplate;
